import { useNavigate } from "react-router-dom";
import logoColorido from "../resources/img/logocolorido.png";
import { useState } from "react";
import { menuItems } from "../Layout/constants";
import { MdDashboard } from "react-icons/md";
import { MdOutlinePointOfSale } from "react-icons/md";
import { MdEvent } from "react-icons/md";
import { IoMdCart } from "react-icons/io";
import { FaUserGroup } from "react-icons/fa6";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { TbReport } from "react-icons/tb";
import { IoLogOut } from "react-icons/io5";
import { CiMenuBurger } from "react-icons/ci";
import { RxCross1 } from "react-icons/rx";

export default function DashboardMenu() {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const iconSize = 18;

  const handleLogoff = () => {
    localStorage.removeItem("eventoId");
    localStorage.removeItem("codEvento");
    localStorage.removeItem("nomeEvento");
    navigate("/");
  };

  return (
    <navbar>
      <div className="hidden sticky top-0 z-50 bg-white mb-4 shadow font-Roboto text-sm font-[500] box-border lg:flex gap-4 w-full justify-between">
        <div className="flex">
          <a
            href="/dashboard"
            className="flex items-center border-b-0 border-t-0 border-l-0 border-r border-solid p-3 gap-4 border-gray-200 text-black no-underline hover:bg-[#ccc] transition"
          >
            <img className="w-[100px] h-auto" alt="logo" src={logoColorido} />
          </a>
          {menuItems.map((item) =>
            !item.inEnd ? (
              <a
                key={item.label}
                href={item.url}
                className="flex items-center gap-2 p-3 border-b-0 border-t-0 border-l-0 border-r border-solid border-gray-200 text-black no-underline hover:bg-[#ccc] transition"
              >
                {item.icon === "MdDashboard" ? (
                  <MdDashboard size={iconSize} />
                ) : item.icon === "MdOutlinePointOfSale" ? (
                  <MdOutlinePointOfSale size={iconSize} />
                ) : item.icon === "MdEvent" ? (
                  <MdEvent size={iconSize} />
                ) : item.icon === "IoMdCart" ? (
                  <IoMdCart size={iconSize} />
                ) : item.icon === "FaUserGroup" ? (
                  <FaUserGroup size={iconSize} />
                ) : item.icon === "MdOutlineRestaurantMenu" ? (
                  <MdOutlineRestaurantMenu size={iconSize} />
                ) : item.icon === "TbReport" ? (
                  <TbReport size={iconSize} />
                ) : null}
                <span>{item.label}</span>
              </a>
            ) : null
          )}
        </div>
        <div className="flex justify-center items-center gap-2 p-3 border-b border-t-0 border-l-0 border-r-0 border-solid border-gray-200 text-black no-underline">
          <span className="text-center font-Oswald font-[600]  text-lg">
            {localStorage.getItem("codEvento")} -{" "}
            {localStorage.getItem("nomeEvento")}
          </span>
        </div>

        <div className="flex">
          {menuItems.map((item) =>
            item.inEnd ? (
              <a
                key={item.label}
                onClick={
                  item.action === "logoff"
                    ? () => {
                        handleLogoff();
                      }
                    : null
                }
                className="flex items-center cursor-pointer gap-2 p-3 border-b-0 border-t-0 border-l border-r-0 border-solid bg-inherit border-gray-200 hover:bg-[#ccc] transition"
              >
                <span>{item.label}</span>
                {item.icon === "IoLogOut" ? <IoLogOut size={iconSize} /> : null}
              </a>
            ) : null
          )}
        </div>
      </div>

      <div className="lg:hidden">
        <div className="p-2">
          <button
            onClick={() => setOpenMenu(!openMenu)}
            className="flex items-center rounded-lg gap-2 p-3 border border-solid border-gray-500 text-black no-underline hover:bg-[#ccc] transition"
          >
            <CiMenuBurger size={iconSize} />
          </button>
        </div>

        {openMenu ? (
          <div className="fixed font-Roboto text-sm font-medium top-0 left-0 w-1/2 bg-white shadow-lg z-50 transition-all">
            <div className="flex flex-col justify-between h-screen">
              <div className="flex flex-col">
                <div className="p-2">
                  <button
                    onClick={() => setOpenMenu(!openMenu)}
                    className="flex items-center rounded-lg gap-2 p-3 border border-solid border-gray-500 text-black no-underline hover:bg-[#ccc] transition"
                  >
                    <RxCross1 size={iconSize} />
                  </button>
                </div>

                <a
                  href="/"
                  className="flex justify-center items-center border-b border-t-0 border-l-0 border-r-0 border-solid p-3 gap-4 border-gray-200 text-black no-underline hover:bg-[#ccc] transition"
                >
                  <img
                    className="w-[100px] h-auto"
                    alt="logo"
                    src={logoColorido}
                  />
                </a>

                <div className="whitespace-nowrap text-ellipsis overflow-hidden flex justify-center items-center gap-2 p-3 border-b border-t-0 border-l-0 border-r-0 border-solid border-gray-200 text-black no-underline">
                  <span className="text-center text-wrap font-Oswald font-[600] text-lg">
                    {localStorage.getItem("codEvento")} -{" "}
                    {localStorage.getItem("nomeEvento")}
                  </span>
                </div>

                {menuItems.map((item) =>
                  !item.inEnd ? (
                    <a
                      href={item.url}
                      className="flex items-center gap-2 p-3 border-b border-t-0 border-l-0 border-r-0 border-solid border-gray-200 text-black no-underline hover:bg-[#ccc] transition"
                    >
                      {item.icon === "MdDashboard" ? (
                        <MdDashboard size={iconSize} />
                      ) : item.icon === "MdOutlinePointOfSale" ? (
                        <MdOutlinePointOfSale size={iconSize} />
                      ) : item.icon === "MdEvent" ? (
                        <MdEvent size={iconSize} />
                      ) : item.icon === "IoMdCart" ? (
                        <IoMdCart size={iconSize} />
                      ) : item.icon === "FaUserGroup" ? (
                        <FaUserGroup size={iconSize} />
                      ) : item.icon === "MdOutlineRestaurantMenu" ? (
                        <MdOutlineRestaurantMenu size={iconSize} />
                      ) : item.icon === "TbReport" ? (
                        <TbReport size={iconSize} />
                      ) : null}
                      <span>{item.label}</span>
                    </a>
                  ) : null
                )}
              </div>
              <div className="flex flex-col">
                {menuItems.map((item) =>
                  item.inEnd ? (
                    <a
                      onClick={
                        item.action === "logoff"
                          ? () => {
                              handleLogoff();
                            }
                          : null
                      }
                      className="flex items-center gap-2 p-3 border-b-0 border-t border-l-0 border-r-0 border-solid border-gray-200 text-black no-underline hover:bg-[#ccc] transition"
                    >
                      {item.icon === "IoLogOut" ? (
                        <IoLogOut size={iconSize} />
                      ) : null}
                      <span>{item.label}</span>
                    </a>
                  ) : null
                )}

                <a className="flex items-center gap-2 p-3 border-b-0 border-t border-l-0 border-r-0 border-solid border-gray-200 text-black no-underline hover:bg-[#ccc] transition">
                  Santa Ficha © {new Date().getFullYear()}
                </a>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </navbar>
  );
}
